import React, { Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
export const CognitoLogoutPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login-sso", { replace: true });
  }, [navigate]);

  return <Fragment></Fragment>;
};
export default CognitoLogoutPage;
